import { Grid, Typography, Button, Card, CardHeader, CardContent, CardActions } from '@mui/material';
import { RoutePaths } from '@shared';
import { RouterNavLink } from '@widgets';

export const DashboardPage = () => {
  return (
    <Grid container alignContent='center'>
      <Grid item xs={12} md={4}>
        <Card>
          <CardHeader title='Coming soon' />
          <CardContent>
            <Typography variant='body1'>TBC what goes into dashboard</Typography>
          </CardContent>
          <CardActions>
            <Button component={RouterNavLink} to={RoutePaths.customers.onNavigate()} color='primary'>
              Search Customers
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};
